// eslint-disable-next-line
export const SEND_INVITATION_EMAIL = 'SEND_INVITATION_EMAIL';
